import React from 'react';
import { Instagram, Youtube, Music, Check } from 'lucide-react';
import toast from 'react-hot-toast';
import type { Platform } from '../../../stores/socialMediaStore';

interface SocialAccountsProps {
  accounts: Array<{
    platform: Platform;
    connected: boolean;
    username?: string;
  }>;
  onConnect: (platform: Platform) => void;
  onDisconnect: (platform: Platform) => void;
}

export default function SocialAccounts({
  accounts,
  onConnect,
  onDisconnect
}: SocialAccountsProps) {
  const handleToggleConnection = (platform: Platform, isConnected: boolean) => {
    if (isConnected) {
      onDisconnect(platform);
      toast.success(`Conta ${platform} desconectada com sucesso!`);
    } else {
      onConnect(platform);
      toast.success(`Conta ${platform} conectada com sucesso!`);
    }
  };

  const getPlatformIcon = (platform: Platform) => {
    switch (platform) {
      case 'instagram':
        return <Instagram className="h-5 w-5 text-pink-600" />;
      case 'youtube':
        return <Youtube className="h-5 w-5 text-red-600" />;
      case 'tiktok':
        return <Music className="h-5 w-5 text-black dark:text-white" />;
    }
  };

  const getPlatformName = (platform: Platform) => {
    return platform.charAt(0).toUpperCase() + platform.slice(1);
  };

  return (
    <div className="bg-white p-6 rounded-lg">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">
        Contas Conectadas
      </h2>

      <div className="space-y-4">
        {accounts.map((account) => (
          <div
            key={account.platform}
            className="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
          >
            <div className="flex items-center space-x-3">
              {getPlatformIcon(account.platform)}
              <div>
                <p className="font-medium">{getPlatformName(account.platform)}</p>
                <p className="text-sm text-gray-500">
                  {account.connected 
                    ? `Conectado como ${account.username}`
                    : 'Não conectado'}
                </p>
              </div>
            </div>
            <button
              onClick={() => handleToggleConnection(account.platform, account.connected)}
              className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center space-x-2 ${
                account.connected
                  ? 'bg-green-50 text-green-600 hover:bg-green-100'
                  : 'bg-indigo-50 text-indigo-600 hover:bg-indigo-100'
              }`}
            >
              {account.connected ? (
                <>
                  <Check className="h-4 w-4" />
                  <span>Conectado</span>
                </>
              ) : (
                'Conectar'
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}